/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Ref_H2Inputs */

const en_formatter_ref_h2 = /** @type {(inputs: Formatter_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output`)
};

const ko_formatter_ref_h2 = /** @type {(inputs: Formatter_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출력`)
};

const ja_formatter_ref_h2 = /** @type {(inputs: Formatter_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力`)
};

/**
* | output |
* | --- |
* | "Output" |
*
* @param {Formatter_Ref_H2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_ref_h2 = /** @type {((inputs?: Formatter_Ref_H2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Ref_H2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_ref_h2(inputs)
	if (locale === "ko") return ko_formatter_ref_h2(inputs)
	return ja_formatter_ref_h2(inputs)
});